module.exports = __webpack_public_path__ + "img/angele-laydee.59203302.jpg";